import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VCol, {
    attrs: {
      "cols": _vm.col.cols || 12,
      "lg": _vm.col.lg || 3,
      "md": _vm.col.md || 6,
      "sm": _vm.col.sm || 12,
      "xs": _vm.col.xs || 12
    }
  }, [_c('div', {
    staticClass: "db-box-container"
  }, [_c('div', {
    staticClass: "db-box-container-small"
  }, [_c(VIcon, {
    staticClass: "db-box-container-icon c-icon",
    class: `bg-info-card-${_vm.color}`,
    attrs: {
      "small": ""
    }
  }, [_vm._v("\n        " + _vm._s(_vm.icon) + "\n      ")]), _c('div', {
    staticClass: "db-contentx"
  }, [_c('div', {
    staticClass: "box-title-elipsis2"
  }, [_c(VTooltip, {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function ({
        on,
        attrs
      }) {
        return [_c('span', _vm._g(_vm._b({}, 'span', attrs, false), on), [_vm._v(_vm._s(_vm.header))])];
      }
    }])
  }, [_c('span', [_vm._v(_vm._s(_vm.header))])])], 1), _c('br'), _c('span', {
    staticClass: "sub-header"
  }, [_vm._v(_vm._s(_vm.subHeader))]), _c('br'), _vm._t("buttons")], 2)], 1), _vm._t("default")], 2)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };